import React, { useEffect, useState } from "react";
import { getDevicesLive } from "./printManager.device.api";
import { useOrg } from "../orgs/org-context";
import DeviceRow from "./DeviceRow";
import PairPrintManager from "./PairPrintManager";
import "./printManager.css";
import { apiFetch } from "../../api/api";

const DevicesPage = () => {
  const { activeOrgId } = useOrg();
  const [pairing, setPairing] = useState(false);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadDevices = async () => {
    try {
      setLoading(true);
      const data = await getDevicesLive();
      setDevices(data);
    } catch (err) {
      console.error("Failed to load Print Managers");
    } finally {
      setLoading(false);
    }
  };

  async function retire(device) {
    if (!window.confirm("Retire this Print Manager? Its installation loses access; history is preserved. To move PCs, use Replace instead.")) return;
    try { await apiFetch("/api/printmanager/pairing/retire", {method:"POST", body:{deviceId:device.deviceId}}); await loadDevices(); }
    catch { window.alert("Unable to retire this Print Manager. Check organization permissions."); }
  }

  useEffect(() => {
    setPairing(false); setDevices([]); loadDevices();

    const interval = setInterval(loadDevices, 8000); // 🔥 auto-refresh
    return () => clearInterval(interval);
  }, [activeOrgId]);

  return (
    <div className="pm-page">
      <div className="pm-header">
        <h2>Print Managers</h2>
        <button onClick={()=>setPairing(true)}>Add Print Manager</button>
        <button onClick={loadDevices}>Refresh</button>
      </div>

      {pairing && <PairPrintManager key={activeOrgId} onClose={()=>setPairing(false)} onConnected={loadDevices} />}
      <div className="pm-table">
        <div className="pm-row pm-header-row">
          <div>Device</div>
          <div>Org</div>
          <div>Status</div>
          <div>Last Seen</div>
          <div>Printers</div>
          <div>Queue</div>
          <div>Actions</div>
        </div>

        {loading && <div className="pm-loading">Loading...</div>}

        {!loading && devices.length === 0 && (
          <div className="pm-empty">No devices found</div>
        )}

        {devices.map((d) => (
          <DeviceRow key={d.deviceId} device={d} onRetire={retire} />
        ))}
      </div>
    </div>
  );
};

export default DevicesPage;
